// M004-F0769 / M004-F0770 / M004-F0771 (WebUI #246 phase 2): the advice-note statement client. Its only operation is the read
// `advice_note.preview` (Spec core-ledger-account-gateway 1.26.0), sent through Core's generic relay (CSLPT):
// POST /api/v1/orgs/:orgId/modules/ledger/messages with the closed envelope { relay_version: 1, type, payload, target_user_id? }.
//
// Read-only: no Idempotency-Key header, no write, nothing cached. The first request carries an empty payload so the Ledger applies its
// defaults; a later request carries { from, to }. target_user_id names the member for an admin view and is omitted for the customer view
// (the customer's envelope is built from the signed-in user only). Errors are thrown unchanged: the caller classifies them
// (src/services/relayOutcome.js) and maps them to messages (src/components/ledger/adviceStatementModel.js).
import api from './api';

const messagesPath = (orgId) => `/v1/orgs/${encodeURIComponent(orgId)}/modules/ledger/messages`;

// period: { from, to } as YYYY-MM strings, or omitted for the Ledger defaults. targetUserId: the member (admin view) or omitted.
export async function previewAdviceNote({ orgId, period, targetUserId } = {}) {
  const envelope = {
    relay_version: 1,
    type: 'advice_note.preview',
    payload: period ? { from: period.from, to: period.to } : {},
    ...(targetUserId != null ? { target_user_id: Number(targetUserId) } : {}),
  };
  const response = await api.post(messagesPath(orgId), envelope);
  return response.data.data.payload;
}
